'use strict';
import React from 'react';


class SummaryList extends React.Component {
    constructor(props) {
        super(props);

    }
    static defaultProps = {
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    };
    findAnnualTotalAvail() {
        let annualTotalAvail = 0;
        let month = new Date().getMonth();

        for (let i = 0; i < this.props.summary.length; i++) {
            if (this.props.summary[i].type == 0) {
                let remainingDays = (11 - month) * (this.props.summary[i].totalGain) / 11;
                annualTotalAvail = remainingDays + this.props.summary[i].leaveGain + this.props.summary[i].bringFwd - this.props.summary[i].used;
                //annualTotalAvail = this.props.summary[i].totalGain + this.props.summary[i].bringFwd - this.props.summary[i].used;
            }
        }
        return annualTotalAvail;
    }
    isWhole = (number) => {
        if (Math.round(number * 100) / 100 == parseInt(number)) {
            return true;
        } else {
            return false;
        }
    }
    renderDataList(i) {
        if (!this.props.summary) return;
        return this.props.summary
            .sort((a, b) => {
                return a.type - b.type;
            })
            .map((summary, index) => {

                if (i == 0) {
                    if (summary.type != 9) {
                        return (<td key={index}>{summary.totalGain ? this.isWhole(summary.totalGain) ? summary.totalGain : summary.totalGain.toFixed(2) : "--"}</td>);
                    } else {
                        let available = 0;
                        let annualTotalAvail = this.findAnnualTotalAvail();
                        available = Math.min(annualTotalAvail, summary.totalGain - summary.used);
                        let totalGain = available + summary.used;

                        return (<td key={index}>{totalGain ? this.isWhole(totalGain) ? totalGain : totalGain.toFixed(2) : "--"}</td>);
                    }
                } else if (i == 1) {
                    return (<td key={index}>{summary.bringFwd ? summary.bringFwd : "--"}</td>);
                } else if (i == 2) {
                    return (<td key={index}>{summary.leaveGain ? summary.leaveGain : "--"}</td>);
                } else if (i == 3) {
                    return (<td key={index}>{summary.used ? summary.used : "--"}</td>);
                } else if (i == 4) {
                    if (summary.type == 0) {
                        let available = summary.bringFwd + summary.leaveGain - summary.used;
                        return (<td key={index}>{available <= 0 ? "--" : this.isWhole(available) ? available : available.toFixed(2)}</td>);
                    } else if (summary.type == 9) {
                        let available = 0;
                        let annualTotalAvail = this.findAnnualTotalAvail();
                        available = Math.min(annualTotalAvail, summary.totalGain - summary.used);

                        return (<td key={index}>{available <= 0 ? "--" : this.isWhole(available) ? available : available.toFixed(2)}</td>);
                    } else {
                        let available = summary.totalGain - summary.used;
                        return (<td key={index}>{available <= 0 ? "--" : this.isWhole(available) ? available : available.toFixed(2)}</td>);
                    }
                }
            });
    }
    renderMainList() {
        let list = [];
        for (let i = 0; i < 5; i++) {
            list = list.concat(
                <tr key={i}>
                    {this.renderDataList(i)}
                </tr>
            );
        }
        return list;
    }

    render() {

        return (
            <div className="sum-wp">
                <div className="sum-l-tt">
                    <div className="sum-li">Leave Entitlement</div>
                    <div className="sum-li">Bring Forward</div>
                    <div className="sum-li">Leave Gain</div>
                    <div className="sum-li">Used</div>
                    <div className="sum-li">Available</div>
                </div>
                <table className="sum-tb">
                    <tbody className={"leave-tbd"}>
                        {this.renderMainList()}
                    </tbody>
                </table>
            </div>
        );
    }
}
export default SummaryList;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/summaryList.js